import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-layout-property',
  templateUrl: './layout-property.component.html',
  styleUrls: ['./layout-property.component.sass']
})
export class LayoutPropertyComponent implements OnInit {
  public tablesTranslate: any;
  constructor(private _translate: TranslateService) { }

  ngOnInit() {
    this.initializeDatablesTranslation();
  }

  initializeDatablesTranslation(): void {
    this._translate.get(['DATATABLE']).subscribe((res) => {
      this.tablesTranslate = res['DATATABLE'];
      localStorage.setItem('dataTablesLang', JSON.stringify(this.tablesTranslate));
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/layout-property/layout-property.component.ts